import { ebGlobalChannel } from "src/lib/events-bridge";
import EBAPIs from "src/lib/events-bridge/topics";
const KeyboardAPIs = {
    publish(eventName, ...args) {
        ebGlobalChannel.publish(EBAPIs.keyboard.event, { eventName, args });
    },
};
export default KeyboardAPIs;
